import ReactDOM from "react-dom"
import App from './App'
import React from 'react';


ReactDOM.render(<App />, document.querySelector("#root")); 